import React from 'react';
import RecentActivityItem from './RecentActivityItem';
import RecentActivitySkeleton from './RecentActivitySkeleton';
import EmptyRecentActivity from './EmptyRecentActivity';
import ErrorBoundary from '../../ui/ErrorBoundary';
import { useRecentActivity } from '../../../hooks/useRecentActivity';

const RecentActivity = () => {
  const { recentActivity, isLoading, error, refetch } = useRecentActivity();


  return (
    <ErrorBoundary
      variant="card"
      title="Recent Activity Error"
      message="Failed to load recent claims activity."
    >
      <div className="bg-crystal-white border border-silver-mist shadow-lg overflow-hidden" style={{ borderRadius: '24px' }}>
        <div className="bg-deep-jungle px-6 py-4 flex justify-between items-center" style={{ borderRadius: '24px 24px 0 0' }}>
          <h3 className="text-lg font-semibold text-crystal-white">Recent Claims Activity</h3>
          <button 
            className="text-xs text-crystal-white hover:text-crystal-white/80 font-medium border border-crystal-white/30 hover:border-crystal-white/50 px-3 py-1 transition-colors duration-200 focus-visible"
            style={{ borderRadius: '8px' }}
            onClick={refetch}
            disabled={isLoading}
          >
            {isLoading ? 'Refreshing...' : 'Refresh'}
          </button>
        </div>
        <div className="min-h-[300px]" style={{ borderRadius: '0 0 24px 24px' }}>
          {isLoading ? (
            <div className="p-6">
              <RecentActivitySkeleton />
            </div>
          ) : error ? (
            <div className="flex flex-col items-center justify-center py-12 px-6">
              <div className="text-center space-y-3">
                <div className="h-12 w-12 mx-auto bg-error/10 flex items-center justify-center" style={{ borderRadius: '12px' }}>
                  <svg className="h-6 w-6 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="text-sm font-medium text-graphite">
                  {error}
                </div>
                <button 
                  className="text-xs text-fresh-leaf hover:text-forest-fern font-medium border border-fresh-leaf/20 hover:border-forest-fern/30 px-3 py-1 transition-colors duration-200 focus-visible"
                  style={{ borderRadius: '8px' }}
                  onClick={refetch}
                >
                  Try again
                </button>
              </div>
            </div>
          ) : recentActivity && recentActivity.length > 0 ? (
            <div style={{ borderRadius: '0 0 24px 24px', overflow: 'hidden' }}>
              {recentActivity.map((claim, index) => (
                <RecentActivityItem 
                  key={`recent-activity-${claim.id}-${index}-${claim.submittedAt || claim.timestamp || Date.now()}`} 
                  claim={claim} 
                />
              ))}
            </div>
          ) : (
            <div className="p-6">
              <EmptyRecentActivity />
            </div>
          )}
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default React.memo(RecentActivity);
